/* =========================================================
   I.META 하드웨어 제품화 파트너 — 페이지 카피 · 표 · FAQ · 단계 데이터
   출처: tmp/imeta-homepage-concept.md — 문구는 문서 원문 그대로 둔다.
   (문서에 없는 문장을 새로 지어 넣지 말 것. 문서가 바뀌면 여기를 같이 고친다)

   회사 정보 · 메뉴 · 개발 사례 · 개발 문의 폼 선택지는 data.js,
   타깃 세그먼트는 segments.js 에 있다.

   톤 원칙 (문서 §3)
   - "저렴하게 · 싸게 · 가성비 개발 · 최저가" 금지, "무엇이든 개발해 드립니다" 금지
   - '최소'는 반드시 "개발비 부담을 최소로" + 파트너/투자/함께 와 묶어서
   - "할인"이 아니라 "투자", "양산권 확보"가 아니라 "양산까지 책임"
   ========================================================= */

/* --------------------------------------------------------
   §1 포지셔닝
   -------------------------------------------------------- */
export const POSITIONING = {
  title: "하드웨어 제품화 파트너",
  titleEn: "Product Venture Partner",
  lines: [
    "개발 조직이 없는 개인·소규모 사업자의 아이디어를 실제 동작하는 제품 → 양산까지 함께 만드는 회사입니다.",
    "선별한 프로젝트에 한해 I.META가 개발비 일부를 기술투자로 부담하고, 양산 대행·로열티·지분으로 성과를 함께 가져갑니다.",
  ],
};

/* --------------------------------------------------------
   §1 핵심 메시지 · 대안 · 보조 메시지 — 사이트 곳곳에서 원문 그대로 쓴다
   -------------------------------------------------------- */
export const MESSAGES = {
  main: "당신의 아이디어, 상품이 될 때까지 함께하는 파트너가 되겠습니다.",
  alt: {
    share: "아이디어를 상품으로. 개발비 부담은 덜고, 성공은 함께 나눕니다.",
    partner: "개발비 부담은 최소로, 파트너십은 끝까지.",
    start: "큰 개발비 없이 시작하세요. 상품이 될 때까지 I.META가 파트너가 되겠습니다.",
  },
  support: {
    field: "당신은 현장을 알고, 우리는 만드는 법을 압니다.",
    invest: "아이디어가 좋다면, 개발비 일부는 I.META가 투자합니다.",
    oneTeam: "회로부터 서버까지, 시제품부터 양산까지. 한 팀에서.",
    proof: "큰 돈 쓰기 전에, 동작하는 실물부터 확인하세요.",
  },
};

/* --------------------------------------------------------
   §5.1 홈 Hero
   헤드라인은 HERO_HEADLINES 중 HERO_ACTIVE 번째를 쓴다 (0 = 핵심 메시지, 1~3 = A/B 대안).
   accent 부분만 그라데이션으로 강조된다. 서브헤드 · 보조 한 줄은 문서 그대로 공통.
   -------------------------------------------------------- */
export const HERO_HEADLINES = [
  { pre: "당신의 아이디어,", accent: "상품이 될 때까지", post: "함께하는 파트너가 되겠습니다." },
  { pre: "아이디어를 상품으로.", accent: "개발비 부담은 덜고,", post: "성공은 함께 나눕니다." },
  { pre: "", accent: "개발비 부담은 최소로,", post: "파트너십은 끝까지." },
  { pre: "큰 개발비 없이 시작하세요.", accent: "상품이 될 때까지", post: "I.META가 파트너가 되겠습니다." },
];
export const HERO_ACTIVE = 0;
export const HERO_SUB =
  "개발비 부담은 최소로. 시제품부터 양산까지 I.META가 함께 만들고, 가능성 있는 아이디어에는 개발비 일부를 직접 투자합니다.";
export const HERO_SUPPORT = MESSAGES.support.field;

/* §5.1-2 이런 분을 위한 곳입니다 (카드 4개) */
export const FOR_YOU = [
  { icon: "Lightbulb", title: "현장에서 '이런 게 있으면 좋겠다'는 게 있다" },
  { icon: "Shield", title: "수천만원 개발비를 먼저 쓰기는 부담된다" },
  { icon: "Layers", title: "전자·소프트웨어를 몰라 어디에 맡길지 모르겠다" },
  { icon: "Box", title: "만든 다음 양산은 어떻게 하는지 막막하다" },
];

/* §2 타깃 공통 특징 */
export const COMMON_TRAITS = [
  "현장에서 겪는 문제와 해결 아이디어가 있다",
  "수천만원 개발비를 먼저 쓰기는 부담스럽다",
  "회로·펌웨어·서버를 각각 발주할 능력이 없다",
  "제조사가 되고 싶은 게 아니라, 제품을 쓰거나 팔고 싶다",
];

/* §5.1-4 I.META가 하는 일 — 한 줄 플로우 */
export const CAPABILITY_FLOW = [
  "회로 설계",
  "PCB",
  "펌웨어",
  "기구/3D프린팅",
  "서버·웹·앱",
  "양산",
];
export const CAPABILITY_NOTE = "쪼개서 여러 업체에 맡길 필요가 없습니다.";

/* §5.1-8 정부지원사업 배너 */
export const FUNDING_BANNER =
  "창업·시제품 지원사업에 선정되셨나요? 또는 준비 중이신가요? 기술 파트를 함께 준비합니다.";

/* §5.1-9 하단 CTA */
export const BOTTOM_CTA = "아이디어만 있어도 됩니다. 먼저 이야기해 주세요.";

/* --------------------------------------------------------
   §5.2 공동개발 /partnership
   -------------------------------------------------------- */
export const PARTNERSHIP_INTRO = [
  "I.META는 모든 프로젝트를 공동개발로 진행하지 않습니다. 기술성·시장성·제품성을 검토해 함께 투자할 가치가 있다고 판단한 프로젝트만 Partnership으로 진행합니다.",
  "개발사가 자기 시간과 비용을 건다는 것 — 그것이 가장 확실한 검증입니다.",
];

/* 3가지 계약 방식 — 각 칸 텍스트. 구체 비율·금액은 표기하지 않는다 */
export const CONTRACT_MODELS = [
  {
    id: "general",
    name: "일반 개발",
    cells: {
      customerCost: "100%",
      investment: "없음",
      reward: "개발비",
      target: "누구나",
      ip: "고객사 보유",
    },
  },
  {
    id: "partnership",
    name: "Partnership",
    highlight: true,
    cells: {
      customerCost: "일부",
      investment: "잔여 개발가치",
      reward: "양산 대행 + 대당 기술료",
      target: "심사 통과 프로젝트",
      ip: "고객사 · I.META 공동 소유",
    },
  },
  {
    id: "venture",
    name: "Venture",
    cells: {
      customerCost: "실비 수준",
      investment: "잔여 개발가치",
      reward: "양산 대행 + 기술료 + 지분(법인)",
      target: "심사 통과 + 판로·실행력 확인",
      ip: "I.META 보유, 고객 사용권",
    },
  },
];

export const CONTRACT_ROWS = [
  { key: "customerCost", label: "고객 부담 개발비" },
  { key: "investment", label: "I.META 기술투자" },
  { key: "reward", label: "I.META 보상" },
  { key: "target", label: "대상" },
  { key: "ip", label: "IP" },
];

export const CONTRACT_NOTE = "구체적인 비율·금액은 검토 후 개별 제안드립니다.";

/* 기술투자 개념 설명 — 예시 박스 */
// TODO: 금액 확정 — 실제 숫자가 정해지면 value 를 바꾼다 (지금은 placeholder)
export const INVEST_EXAMPLE = [
  { label: "총 개발가치", value: "○,○○○만원" },
  { label: "고객 부담", value: "○○○만원" },
  { label: "I.META 기술투자", value: "○,○○○만원", accent: true },
];
export const INVEST_NOTE =
  "개발비를 깎아드리는 것이 아니라, I.META가 귀하의 사업에 투자하는 것입니다.";

export const MASS_PRODUCTION = {
  title: "양산까지 책임집니다",
  desc: "부품 수급, PCB 발주, 조립, 검사, 펌웨어 업데이트까지. 사장님은 제품을 팔고 쓰는 데만 집중하세요.",
};

export const ROLES = [
  { who: "고객", items: ["시장", "고객", "영업", "판매"] },
  { who: "I.META", items: ["제품", "기술", "제조"], accent: true },
];

export const CRITERIA = [
  "누가 살 것인가",
  "돈을 낼 이유가 있는가",
  "문의하신 분이 그 현장을 잘 아는가",
  "문의하신 분에게 판매·유통 능력이 있는가",
  "MVP를 1~2개월 안에 만들 수 있는가",
  "판매 시 반복 생산되는 제품인가",
];

export const PARTNERSHIP_FAQ = [
  { q: "아이디어가 유출되지 않나요?", a: "상담 전 비밀유지계약(NDA)을 체결할 수 있습니다." },
  { q: "심사에서 떨어지면?", a: "일반 개발로 진행하거나, 보완 의견을 드립니다." },
  { q: "개인사업자도 되나요?", a: "가능합니다. 지분 대신 양산 대행·기술료 방식으로 진행합니다." },
  { q: "양산을 다른 곳에서 하고 싶어지면?", a: "계약 시 정산 기준을 미리 정합니다." },
  { q: "지역은?", a: "광주·전남은 대면 미팅을 우선하고, 그 외 지역은 온라인으로 진행합니다." },
];

/* --------------------------------------------------------
   §5.3 진행 방식 /process — 기간·비용 값은 여기서만 고친다
   -------------------------------------------------------- */
export const STAGES = [
  { step: "0", title: "아이디어 검토", desc: "시장성·제작 난이도·예상 원가 검토", period: "1주 내", cost: "무료" },
  { step: "1", title: "PoC", desc: "핵심 기능만 동작하는 실물", period: "2~4주", cost: "소액" },
  { step: "2", title: "MVP", desc: "실제 사용 가능한 시제품", period: "1~2개월", cost: "계약 방식별" },
  { step: "3", title: "양산 설계", desc: "원가 절감·생산성 설계", period: "협의", cost: "계약 방식별" },
  { step: "4", title: "양산·공급", desc: "I.META 양산 대행", period: "지속", cost: "대당 공급가" },
];
export const STAGE_NOTE =
  "각 단계가 끝날 때마다 계속할지 결정합니다. 큰돈을 한 번에 걸지 않아도 됩니다.";

/* --------------------------------------------------------
   §5.5 정부지원사업 연계 /funding — 특정 사업명·금액은 하드코딩하지 않는다(매년 변동)
   -------------------------------------------------------- */
export const FUNDING = {
  headline: "지원사업에 선정되셨나요? 지원금으로 실제 동작하는 제품을 만드세요.",
  lead: "창업패키지·아이디어 공모전·시제품 제작 지원사업의 개발 예산으로 I.META와 진행할 수 있습니다.",
  /* 올해 공고 등 수시로 바뀌는 안내 — 비워 두면 표시하지 않는다 */
  notice: "",
  targets: [
    "지원사업 선정 후 외주 개발처를 찾는 창업자",
    "지원사업 신청을 준비 중인 예비 창업자",
  ],
  offers: [
    "사업계획서 기술 파트(기술 개요·개발 일정·구현 방안) 작성 지원",
    "협약 예산·기간에 맞춘 개발 범위 설계",
    "선정 후 시제품 개발 수행 및 기간 내 납품",
    "집행 증빙용 견적서·계약서·검수 자료, 결과보고서 기술 자료 제공",
    "지원사업 종료 후 양산·후속 지원사업 연계",
  ],
  flow: ["상담", "개발 범위·견적", "협약 예산 반영", "계약", "개발·중간 점검", "납품·검수", "양산 연계"],
  faq: [
    {
      q: "지원금으로 외주 개발비를 집행할 수 있나요?",
      a: "대부분 가능하나 사업별 집행 기준이 다르므로 공고문·전담기관 확인이 필요합니다.",
    },
    { q: "아직 선정 전인데 상담 가능한가요?", a: "가능합니다. 신청 단계부터 기술 파트를 함께 준비합니다." },
    { q: "지원금이 개발비보다 부족하면?", a: "범위 조정 또는 Partnership 방식 병행을 검토합니다." },
  ],
  disclaimer: "지원사업 선정 여부는 보장하지 않습니다.",
};

/* --------------------------------------------------------
   §5.7 소개 /about — 개인 이력 나열 금지, 회사 역량 중심
   -------------------------------------------------------- */
export const ABOUT = {
  title: "하드웨어부터 웹까지 한 팀에서 처리하는 제품화 파트너",
  tech: [
    { icon: "Circuit", label: "회로 설계" },
    { icon: "Chip", label: "PCB 설계" },
    { icon: "Code", label: "MCU 펌웨어" },
    { icon: "Server", label: "리눅스 디바이스 드라이버" },
    { icon: "Box", label: "3D 모델링·프린팅" },
    { icon: "Globe", label: "서버·웹·앱" },
    { icon: "Brain", label: "AI 활용 개발" },
  ],
  /* 사진은 public/about/ 에 넣는다. 파일이 없으면 사진 칸만 빠지고 항목은 그대로 보인다 */
  equipment: [
    { label: "계측 장비", photo: "/about/equipment-measure.webp" },
    { label: "전원 장비", photo: "/about/equipment-power.webp" },
    { label: "납땜 장비", photo: "/about/equipment-solder.webp" },
    { label: "3D 프린터", photo: "/about/equipment-3dprinter.webp" },
  ],
  location: "광주 — 대면 미팅 가능",
};

/* =========================================================
   서비스 — 제품개발(/partnership) · 웹사이트 개발 · 개발지원
   ========================================================= */

/* /services 소개 페이지 */
export const SERVICES_HUB = {
  title: "서비스",
  lead: "I.META는 네 가지 서비스를 제공합니다.",
};

/* 웹사이트 개발 서비스 — 소상공인 · 자영업자 홈페이지 빠른 구축 */
export const WEBSITE_SERVICE = {
  headline: "우리 가게 홈페이지, 빠르게 만들어 드립니다.",
  lead: "소상공인, 특히 혼자 또는 몇 명이 운영하는 자영업자를 위한 홈페이지입니다. 꼭 필요한 내용만 담아 빠르게 구축합니다.",
  price: "기본료 20만원부터",
  priceNote: "페이지 수와 기능에 따라 달라지며, 상담 후 금액을 안내드립니다.",
  who: ["식당 · 카페", "미용실 · 네일샵", "공방", "학원 · 교습소", "소매점", "그 밖의 자영업"],
  /* 기본료 포함 범위가 정해지면 included 로 나눠 표기한다. 지금은 '담을 수 있는 것' 안내 */
  features: [
    "휴대폰에서 보기 좋은 화면",
    "가게 소개 · 사진",
    "메뉴 · 가격 안내",
    "위치 지도 · 영업시간",
    "전화 · 문자 · 카카오톡 바로 연결",
    "검색 노출을 위한 기본 설정",
  ],
  extras: [
    "예약 · 주문 연동",
    "메뉴 · 가격을 직접 고치는 관리 화면",
    "공지 · 이벤트 게시판",
  ],
  flow: ["상담", "자료 전달 (사진 · 메뉴 · 소개글)", "제작", "확인 · 수정", "오픈"],
  reference: { to: "/works#e-menu", label: "소규모 식당용 전자 메뉴판 개발 사례 보기" },
  inquiryType: "웹사이트 제작",
};

/* 개발지원 서비스 — 직접 개발은 하지 않는 컨설팅 */
export const CONSULTING_SERVICE = {
  headline: "직접 개발하지 않고, 개발이 제대로 되도록 돕습니다.",
  lead: "개발지원 서비스는 I.META가 실제 개발을 진행하지 않는 컨설팅 서비스입니다. 회로 · PCB · 펌웨어 · 서버 중 필요한 구간에 대해 검토하고 자문합니다.",
  areas: [
    { icon: "Circuit", label: "회로 · PCB" },
    { icon: "Code", label: "펌웨어" },
    { icon: "Box", label: "기구 · 3D프린팅" },
    { icon: "Server", label: "서버 · 웹 · 앱" },
  ],
  items: [
    "설계 · 사양 검토",
    "기술 방향 · 부품 선정 자문",
    "외주 개발사 사양서 · 견적 검토",
    "개발 중 문제의 원인 진단 · 해결 방향 제시",
    "양산 전 설계 점검",
  ],
  note: "개발은 직접 진행하지 않습니다. 직접 개발이 필요하면 제품개발 서비스로 이어서 진행할 수 있습니다.",
  inquiryType: "개발지원 컨설팅",
};

/* =========================================================
   개발 분야별 서비스 — /services/<slug>
   '외주 개발사'를 찾는 검색(PCB 설계 외주, 펌웨어 개발 업체, 시제품 제작 …)에
   걸리도록 분야마다 독립 페이지를 둔다. (2026-10 검색 노출 점검에서 추가)
   문서 §3 톤 원칙은 그대로 지킨다 — 저렴 · 가성비 · "무엇이든" 금지.
   내용은 실제 수행한 기술 · 사례(works 의 id)만 적는다.
   ========================================================= */
export const TECH_SERVICES = [
  {
    slug: "pcb-design",
    label: "회로 · PCB 설계",
    desc: "회로도 · PCB 아트웍 · 제작 · 조립",
    icon: "Circuit",
    seoTitle: "회로 설계 · PCB 설계 외주 — 회로도부터 아트웍 · 제작 · 조립까지 | I.META 아이닷메타",
    seoDesc:
      "전자회로 설계 · PCB 설계 외주. 부품 선정, 회로도, PCB 아트웍, 거버 · BOM 출력, PCB 제작 · SMT 조립 발주, 실장 보드 검증까지 진행합니다. 시제품 소량부터 양산 설계까지, 펌웨어도 같은 팀에서. PCB 설계 업체 I.META.",
    headline: "회로도부터 실장된 보드까지, 한 번에 맡기세요.",
    lead: "부품 선정과 회로 설계, PCB 아트웍, 제작 · 조립 발주, 실장 후 동작 검증까지 진행합니다. 보드가 나온 뒤의 펌웨어와 케이스도 같은 팀에서 이어서 만듭니다.",
    items: [
      "요구 사양 정리 · 부품 선정",
      "회로도 설계 — 전원 · MCU · 센서 · 통신 · 모터 구동",
      "PCB 아트웍 · 거버 · BOM · 조립 도면",
      "PCB 제작 · SMT 조립 발주와 부품 수급",
      "실장 보드 동작 검증 · 수정 설계(리비전)",
      "양산을 고려한 설계 점검 · 원가 검토",
    ],
    tech: ["MCU 보드", "센서 · 아날로그 입력", "고분해능 ADC", "모터 드라이버", "RS485 · UART · SPI · I2C", "서지 보호 회로"],
    works: ["aspv", "kinetic-motion", "kiosk-surge"],
    faq: [
      { q: "아이디어만 있어도 회로 설계를 맡길 수 있나요?", a: "가능합니다. 필요한 기능과 사용 환경을 듣고 사양 정리부터 시작해 회로 설계 · PCB 설계로 이어서 진행합니다." },
      { q: "PCB 제작과 조립까지 맡길 수 있나요?", a: "PCB 제작 · SMT 조립 발주와 부품 수급을 함께 진행하고, 실장된 보드의 동작을 확인한 뒤 전달합니다." },
      { q: "설계 파일을 받을 수 있나요?", a: "일반 개발로 진행한 결과물(회로도 · 거버 · BOM)은 고객사가 보유합니다. Partnership 은 계약 조건에 따릅니다." },
    ],
    inquiryType: "회로 · PCB",
  },
  {
    slug: "firmware",
    label: "임베디드 펌웨어 개발",
    desc: "STM32 · ESP32 · 라즈베리파이",
    icon: "Code",
    seoTitle: "임베디드 펌웨어 개발 외주 — STM32 · ESP32 · 라즈베리파이 · 리눅스 | I.META 아이닷메타",
    seoDesc:
      "MCU 펌웨어 개발 외주. STM32 · ESP32 펌웨어, 라즈베리파이 · 리눅스 디바이스 드라이버, 센서 계측 · 모터 제어, RS485 · UART · SPI · I2C 통신, PC 프로그램 · 웹 · 앱 연동까지. 회로를 설계하는 팀이 펌웨어를 만듭니다.",
    headline: "보드를 설계한 팀이 펌웨어까지 만듭니다.",
    lead: "STM32 · ESP32 같은 MCU 펌웨어와 라즈베리파이 · 리눅스 기반 장치의 소프트웨어를 개발합니다. 회로와 펌웨어를 한 팀이 맡아, 문제가 생겼을 때 하드웨어와 소프트웨어 사이에서 원인을 떠넘기지 않습니다.",
    items: [
      "센서 입력 · 데이터 수집 · 필터링",
      "스테퍼 · DC 모터 구동과 모션 제어",
      "RS485 · UART · SPI · I2C 통신 프로토콜",
      "Wi-Fi · BLE 무선 통신 (ESP32)",
      "라즈베리파이 · 리눅스 디바이스 드라이버",
      "PC 프로그램 · 웹 · 앱과의 통신 연동",
    ],
    tech: ["STM32", "ESP32", "Raspberry Pi", "리눅스 디바이스 드라이버", "RS485 멀티드롭", "부트로더"],
    works: ["kinetic-motion", "kineticpro", "aspv"],
    faq: [
      { q: "기존 제품의 펌웨어 수정만 맡길 수 있나요?", a: "소스 코드와 회로도가 있으면 분석한 뒤 수정 범위와 일정을 안내드립니다. 소스가 없는 경우는 상담 후 판단합니다." },
      { q: "펌웨어와 PC · 앱 프로그램을 함께 맡길 수 있나요?", a: "가능합니다. 통신 프로토콜을 한 곳에서 정의해 펌웨어와 PC 소프트웨어가 서로 어긋나지 않게 만듭니다." },
      { q: "보드가 이미 있는데 펌웨어만 개발할 수 있나요?", a: "가능합니다. 회로도를 먼저 검토하고, 펌웨어로 해결할 수 없는 하드웨어 문제가 보이면 함께 알려 드립니다." },
    ],
    inquiryType: "펌웨어",
  },
  {
    slug: "prototyping",
    label: "전자제품 시제품 제작",
    desc: "PoC · MVP 동작 시제품",
    icon: "Rocket",
    seoTitle: "전자제품 시제품 제작 — 아이디어를 동작하는 시제품으로, PoC · MVP · 양산 연계 | I.META 아이닷메타",
    seoDesc:
      "전자제품 · IoT 시제품 제작. 회로 · PCB · 펌웨어 · 3D프린팅 케이스 · 앱/서버를 한 팀에서 만들어 2~4주 PoC, 1~2개월 MVP 로 동작하는 실물을 확인합니다. 창업 시제품, 정부지원사업 시제품, 크라우드펀딩 시제품, 양산 연계까지.",
    headline: "큰 돈 쓰기 전에, 동작하는 실물부터 확인하세요.",
    lead: "회로 · PCB · 펌웨어 · 기구(3D프린팅) · 앱과 서버까지 한 팀에서 만들어, 핵심 기능이 실제로 동작하는 시제품을 내놓습니다. 시제품에서 끝나지 않고 양산까지 이어지도록 설계합니다.",
    items: [
      "아이디어 검토 — 구현 방법 · 예상 원가 (1주 내, 무료)",
      "PoC — 핵심 기능만 동작하는 실물 (2~4주)",
      "MVP — 실제 사용 가능한 시제품 (1~2개월)",
      "3D 모델링 · 3D프린팅 케이스 · 지그",
      "앱 · 웹 · 서버와 연결되는 시제품",
      "크라우드펀딩 · 전시 · 지원사업 결과물용 시제품",
    ],
    tech: ["회로 설계", "PCB", "펌웨어", "3D 모델링 · 프린팅", "서버 · 웹 · 앱", "양산 설계"],
    works: ["kinetic-motion", "aspv", "e-menu"],
    faq: [
      { q: "아이디어만 있는데 시작할 수 있나요?", a: "가능합니다. 아이디어 검토 단계에서 구현 방법과 예상 원가를 먼저 정리해 드립니다." },
      { q: "정부지원사업 예산으로 시제품을 만들 수 있나요?", a: "대부분 가능하나 사업별 집행 기준이 다르므로 공고문 · 전담기관 확인이 필요합니다. 사업계획서 기술 파트부터 함께 준비합니다." },
      { q: "시제품 이후 양산도 맡길 수 있나요?", a: "양산 설계와 부품 수급, PCB 발주, 조립, 검사, 펌웨어 업데이트까지 I.META가 진행합니다." },
    ],
    links: [
      { to: "/process", label: "단계별 진행 방식 보기" },
      { to: "/funding", label: "정부지원사업 연계 보기" },
    ],
    inquiryType: "일반 개발 의뢰",
  },
  {
    slug: "esp32",
    label: "ESP32 · IoT 개발",
    desc: "Wi-Fi · BLE 로 연결되는 기기",
    icon: "Sensor",
    seoTitle: "ESP32 개발 외주 — IoT 기기 · Wi-Fi · BLE 펌웨어 · 웹/앱 · 서버 연동 | I.META 아이닷메타",
    seoDesc:
      "ESP32 개발 외주. ESP32 회로 · PCB 설계, Wi-Fi · BLE 펌웨어, 센서 원격 모니터링 · 원격 제어 IoT 기기, 웹 대시보드 · 앱 · 서버 연동까지 한 팀에서 개발합니다. ESP32-C3 모듈과 ESP32 오픈 로봇 라오나봇을 직접 만든 팀입니다.",
    headline: "센서에서 휴대폰 화면까지, ESP32로 연결합니다.",
    lead: "ESP32 기반 IoT 기기의 회로 · PCB, Wi-Fi · BLE 펌웨어, 데이터를 받는 서버와 웹 · 앱 화면까지 한 팀에서 개발합니다. 원격으로 상태를 확인하거나 제어해야 하는 장치에 맞습니다.",
    items: [
      "ESP32 계열 모듈 선정 · 보드 설계",
      "Wi-Fi · BLE 통신 펌웨어",
      "센서 데이터 수집 · 원격 모니터링",
      "릴레이 · 모터 · 조명 원격 제어",
      "웹 대시보드 · 앱 · 서버 연동",
      "무선 펌웨어 업데이트(OTA)",
    ],
    tech: ["ESP32 · ESP32-C3", "Wi-Fi · BLE", "WebSocket · HTTP API", "FastAPI 서버", "웹 대시보드", "OTA 업데이트"],
    works: [],
    faq: [
      { q: "꼭 앱까지 만들어야 하나요?", a: "그렇지 않습니다. 휴대폰 브라우저로 여는 웹 화면으로 충분한 경우가 많아, 용도에 맞는 방식을 제안드립니다." },
      { q: "ESP32 보드만 구매할 수도 있나요?", a: "I.META가 만든 ESP32-C3 MCU 모듈을 판매제품에서 구매할 수 있습니다." },
      { q: "와이파이가 없는 곳에서도 쓸 수 있나요?", a: "BLE 로 휴대폰과 직접 연결하거나, 기기끼리 통신하는 방식으로 구성할 수 있습니다. 설치 환경을 듣고 방식을 정합니다." },
    ],
    links: [
      { to: "/products/md-mcu-001", label: "ESP32-C3 MCU 모듈 보기" },
      { to: "/laonabot", label: "라오나봇 — ESP32 오픈 로봇" },
    ],
    inquiryType: "펌웨어",
  },
  {
    slug: "industrial",
    label: "계측 · 제어 장치 개발",
    desc: "센서 계측 · 모션 제어 · 장비 보드",
    icon: "Pulse",
    seoTitle: "계측 · 제어 장치 개발 외주 — 다채널 센서 계측 · 모터 모션 제어 · 장비용 보드 | I.META 아이닷메타",
    seoDesc:
      "산업용 · 연구용 계측 장치와 제어 장치 개발 외주. 다채널 센서 동기 계측, 스테퍼 모터 모션 제어, RS485 네트워크, 장비용 서지 보호 보드 · 케이블, 측정값 시각화 소프트웨어까지. 실제 수행 사례로 보여드립니다.",
    headline: "현장에서 멈추지 않고 동작하는 장치를 만듭니다.",
    lead: "센서 계측, 모터 구동, 장비 내부 보드처럼 오래 · 안정적으로 동작해야 하는 장치를 개발합니다. 하드웨어와 제어 펌웨어, 측정값을 보여 주는 PC · 웹 소프트웨어까지 함께 만듭니다.",
    items: [
      "다채널 센서 동기 스캔 · 고분해능 ADC 계측",
      "스테퍼 모터 모션 제어 · 스톨 감지 · 페일세이프",
      "RS485 멀티드롭으로 여러 컨트롤러 통합 제어",
      "장비용 서지 보호 보드 · 전장 케이블 하네스",
      "측정값 실시간 시각화 · 기록 소프트웨어",
      "1대 제작부터 반복 생산까지",
    ],
    tech: ["고분해능 ADC", "스테퍼 모터 · 볼스크류 · LM 가이드", "RS485", "서지 보호", "Raspberry Pi", "FastAPI · WebSocket"],
    works: ["aspv", "aspv-gui", "kinetic-motion", "kineticpro", "kiosk-surge"],
    faq: [
      { q: "1대만 필요한 장비도 개발하나요?", a: "가능합니다. 연구 · 전시 · 현장용 1대 제작도 진행하며, 반복 생산이 필요해지면 양산 설계로 이어집니다." },
      { q: "측정 데이터를 PC나 웹에서 볼 수 있나요?", a: "측정값을 실시간으로 받아 그래프 · 히트맵으로 보여 주는 PC · 웹 소프트웨어를 함께 개발합니다." },
      { q: "기구 설계도 함께 하나요?", a: "구동부 축 구성, 브래킷 · 케이스 3D 모델링과 3D프린팅까지 함께 진행합니다." },
    ],
    inquiryType: "일반 개발 의뢰",
  },
];
